<template>
    <div>
        <div :class="['upFileBox upFileBox-'+item.type]" v-for="(item,index) in filelist" :key="index">
            <i class="el-icon-delete-solid removeImg" @click="del(item,index)"></i>
            <div :class="['showImg',{'show':item.cover}]" :style="{'background':'url('+item.cover+') no-repeat center'}" @click="pre(item,index)"></div>
            <div :class="['upIng upStatus upMask',{'show':item.upStatus=='upIng'}]" @click="pre(item)"><b class="upWen">上传中...</b></div>
            <div :class="['upErr upStatus upMask',{'show':item.upStatus=='upErr'}]" @click="pre(item)"><i class="errIcon"></i><b class="upWen">上传失败</b></div>
            <div :class="['upSuc upStatus',{'show':item.upStatus=='upSuc'}]"></div>
        </div>
        <div v-if="!limit || filelist.length<limit" class="upFileBox" v-show="!hideTriggerBtn">
            <div class="upFileBox-video upFileBtn" v-if="type=='video'">
                <div class="upTipWenBox">
                    <i class="upTipWenIcon"></i>
                    <div class="upTipWen">请上传MP4格式的视频</div>
                </div>
                <input type="file" class="file" accept="video/mp4" ref="file" @change="chooseFile()"/>
            </div>
            <div class="upFileBox-image upFileBtn" v-else-if="type=='image'">
                <div class="upTipWenBox">
                    <i class="upTipWenIcon"></i>
                    <div class="upTipWen">请上传图片</div>
                </div>
                <input type="file" class="file" accept="image/png,image/jpeg" ref="file" @change="chooseFile()"/>
            </div>
            <div class="upFileBox-audio upFileBtn" v-else-if="type=='audio'">
                <div class="upTipWenBox">
                    <i class="upTipWenIcon"></i>
                    <div class="upTipWen">请上传MP3格式的音频</div>
                </div>
                <input type="file" class="file" accept="audio/mp3" ref="file" @change="chooseFile()"/>
            </div>
            <div class="upFileBox-all upFileBtn" v-else-if="type=='video,audio'">
                <div class="upTipWenBox">
                    <i class="upTipWenIcon"></i>
                    <div class="upTipWen">请上传文件</div>
                </div>
                <input type="file" class="file" accept="image/png,image/jpeg,video/mp4" ref="file" @change="chooseFile()"/>
            </div>
            <div class="upFileBox-all upFileBtn" v-else>
                <div class="upTipWenBox">
                    <i class="upTipWenIcon"></i>
                    <div class="upTipWen">请上传文件</div>
                </div>
                <input type="file" class="file" accept="image/png,image/jpeg,video/mp4,audio/mp3" ref="file" @change="chooseFile()"/>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
/*上传box公共样式*/
.upFileBox{width:180px;height: 150px;position:relative;border:1px solid #ddd;text-align:center;
	display:-webkit-flex;display:flex;-webkit-justify-content:center;justify-content:center;
	-webkit-align-items:center;align-items:center;display:inline-block;color:#aaa;margin:0 15px 15px 0;}
.upFileBox .upMask{position:absolute;width:100%;height:100%;left:0;top:0;background:rgba(0,0,0,.3);
	display:-webkit-flex;display:flex;-webkit-align-items:center;align-items:center;
	-webkit-justify-content:center;justify-content:center;z-index:3;}
.upFileBox .upStatus{display:none;}
.upFileBox .upStatus.show{display:-webkit-flex !important;display:flex !important;}
.upFileBox .upWen{font-size:16px;color:#fff;}
.upFileBox .upSuc{position:absolute;bottom:4px;right:4px;font-size:26px;color:#f54933;top:auto;z-index:3;}
.upFileBox .upSuc:before{content:"\e79c";font-family:element-icons!important;font-size:24px;font-weight:bold;}
.upFileBox .errIcon:before{content:"\e79d";font-family:element-icons!important;font-size:20px;font-style:normal;color:#fff;line-height:1.2;font-weight:bold;}
.upFileBox .showImg{position:absolute;top:0;left:0;width:100%;height:100%;margin:0;background-size:cover !important;display:none;}
.upFileBox .showImg.show{display:block;}
.upFileBox .removeImg{position:absolute;right:0px;top:0px;z-index:10;padding:4px 4px 6px 6px;font-size:18px;color:#fff;background:rgba(0,0,0,.4);
cursor:pointer;border-radius:0 0 0 8px;visibility:hidden;opacity:0;-webkit-transition:0.3s;transition:0.3s;}
.upFileBox:hover .removeImg{visibility:visible;opacity:1;}
.upFileBox .upTipWenBox{width:98%;position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);}
.upFileBox .upTipWen{font-size:14px;color:#aaa;text-align:center;margin-top:2%;}
.upFileBox .file{position:absolute;top:0;left:0;width:100%;height:100%;opacity:0;}
.upFileBox .upTipWenIcon{position:relative;top:1px;display:inline-block;font-family:element-icons!important;
    font-style:normal;font-weight:400;line-height:1;-webkit-font-smoothing: antialiased;color:#aaa;font-size:42px;}
.upFileBox-image .upTipWenIcon:before{content:"\e79f";}
.upFileBox-audio .upTipWenIcon:before{content:"\e799";}
.upFileBox-video .upTipWenIcon:before{content:"\e796";}
.upFileBox-all .upTipWenIcon:before{content:"\e6d9";}
.showImg{position:relative;font-family:element-icons!important;font-size:42px;color:#fff;}
.showImg:after{content:'';position:absolute;width:100%;height:100%;top:0;left:0;background-color:rgba(0,0,0,.2);z-index:1;}
.showImg:before{z-index:2;position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);}
.upFileBox-audio .showImg:before{content:"\e799";z-index:2;}
.upFileBox-video .showImg:before{content:"\e7c0";z-index:2;}
.upFileBox-image .showImg:before{content:"";}
.upFileBox-audio:after{display:block;}
.upFileBox-video:after{display:block;}
</style>

<script>
export default {
    name: "upItem",
    components: {
    },
    props:{
        filelist:{
            type: Array,
            default: [],
        },
        folder: {
            type: String,
            default: 'studio',
        },
        type: {
            type: String,
            default: '',
        },
        limit: {
            type: [String,Number,Object],
            default: null,
        },
        upVideoDuration:{
            type: [String,Number,Object,Boolean],
            default: false,
        },
        upVideoCover:{
            type: [String,Number,Object,Boolean],
            default: false,
        },
        //是否需要隐藏触发上传按钮
        hideTriggerBtn:{
            type: [Boolean],
            default: false,
        },
        //是否需要自定义操作，是否直接删除
        deleteDirectly:{
            type: [Boolean],
            default: true,
        },
        //新元素是否往前插入,默认push
        unshift:{
            type: [Boolean],
            default: false,
        },
    },
    data(){
        return {
            showImgUrl: '',
            upStatus: '',
            defaultCover: require('@/assets/img/defaultCover.png'),
        }
    },
    watch:{
        //监听upStatus值变化
        upStatus(newval,oleval){
            this.onUpStatus(newval);
        }
    },
    methods:{
        chooseFile: function(){
            var vm = this;
            var obj = event.target;
            var objUrl = vm.$utils.getObjectURL(obj.files[0]); //上传图片地址
            var fileSize = (obj.files[0].size / 1024).toFixed(1); //上传图片的大小（单位：kb）
            var fileName = obj.files[0].name; //上传图片名
            var fileType = obj.files[0].type; //上传图片类型
            var folder = this.folder;
            console.log(fileType);
            let item = {
                blob: objUrl,
                ossurl: '',
                cover: '',
                upStatus: 'upIng',
                catalog: folder,
                thumb: '' ,
                duration: '',
                filename: '', //文件名
                extension: '',//后缀名
                minetype: '', //文件类型（视频、图片）
                type: '', //image ,video, audio
            }
            if(vm.unshift){
                vm.filelist.unshift(item);
            }else{
                vm.filelist.push(item);
            }
            console.log(vm.filelist,'vm.filelist');
            //视频
            if (fileType == "video/mp4" ) {
                console.log("视频");
                item.type = 'video';
                item.cover = vm.defaultCover;
                if (fileSize>(1024*200)) {//(1024*20) 200M
                    this.$message("artapp提示", "单张图片不能超过200M哦！");
                    return false;
                }
                if (objUrl) {
                    console.log(objUrl);
                    let needWaitNum = 1;
                    let hasSucNum = 0;
                    //需要获取视频封面图
                    if( vm['upVideoDuration'] ){
                        needWaitNum++;
                        //获取视频时长
                        vm.calcVideoDuration(objUrl,function(dua){
                            item.duration = vm.$utils.toFixed(dua,1);
                            console.log(dua+'==>'+item.duration,'获取视频时长suc');
                            hasSucNum++;
                            check();
                        });
                    }

                    //上传资源到oss服务器，获取资源地址
                    vm.uploadOss(item, obj.files[0], this.type, folder, function(url){
                        console.log(url,'资源上传成功');
                        hasSucNum++;
                        //需要获取视频封面图
                        if( vm['upVideoCover'] ){
                            needWaitNum++;
                            vm.$utils.getNewImgUrl(item.cover,folder,function(url){
                                console.log(url,'视频截图上传成功');
                                item.thumb = url;
                                hasSucNum++;
                                check();
                            },function(){
                                item.upStatus = 'upErr';
                            })
                        }else{
                            check();
                        }
                    },function(){
                        item.upStatus = 'upErr';
                    });

                    //判断是否upSuc(1.upVideoDuration为true的前提下，时长是否获取到了 2.是否资源上传成功)
                    function check(){ 
                        if( hasSucNum >= needWaitNum ){
                            item.upStatus = 'upSuc';
                            vm.onSuccess(item);
                        }
                    }
                }
            }
            if(fileType == "image/png" || fileType == "image/jpeg"){
                item.cover = objUrl;
                item.type = 'image';
                //上传资源到oss服务器，获取资源地址
                vm.uploadOss(item, obj.files[0], this.type, folder, function(url){
                    console.log(url,'图片上传成功');
                    item.upStatus = 'upSuc';
                    vm.onSuccess(item);
                },function(){
                    item.upStatus = 'upErr';
                });
            }
        },

        uploadOss(item, file, type, folder,suc,err){
            let vm = this;
            vm.$utils.UpFileToOss(file, type, folder, function(url){
                //上传成功
                //item.upStatus = 'upSuc';
                item.ossurl = url;
                var filename = url.split(folder+'/')[1].split('.')[0];
                var extension = url.split(folder+'/')[1].split('.')[1];
                var minetype = '';
                var type = vm.$utils.checkSourceUrlType(url);
                console.log(type,'type');
                 if( type=='video' ){
                    item.cover = vm.$utils.addOssResize(vm.$utils.getOssVideoSnapshot(url,100,'png'),300);
                }
                switch(type){
                    case 'image': minetype = '图片'; break;
                    case 'video': minetype = '视频'; break;
                    case 'audio': minetype = '音频'; break;
                }
                item.filename = filename;
                item.extension = extension;
                item.minetype = minetype;
                suc(url);
            }, 
            function(res){
                //上传失败
                console.log(res);
                err(res);
                //item.upStatus = 'upErr';
                //vm.onError(res);
            }, false,
            function(p,checkpoint){
                console.log(p,'pp');
            });
            vm.$refs.file.value = '';//清空，避免下次上传同一个文件，无法触发change事件
        },

        calcVideoDuration: function (url,callback){
            var audio = new Audio(url)
            // 元数据已加载
            audio.addEventListener("loadedmetadata", function (e) {
                let duration = audio.duration; 
                callback(duration)
            });
        },  

        //上传成功
        onSuccess(item){
            this.$emit("on-success",item,this.filelist);
        },
        //上传失败
        onError(res){
            this.$emit("on-error",res)
        },
        //上传状态
        onUpStatus(res){
            this.$emit("on-status",res);
        },

        del(item,index){
            if(this.deleteDirectly){
                this.filelist.splice(index,1);
            }
            this.$emit("on-delete",item,index);
        },

        pre(obj){
            let url = obj.blob ? obj.blob : (obj.ossurl ? this.$utils.addOssurlHeader(obj.ossurl) : '');
            if(!url) return;
            this.$preSource(url,obj.type);
        },

        triggerSelectFile(){
            this.$refs.file.click();
        }
       
    },

    created(){
    },
    mounted(){
    }
};
</script>
